// src/Auth.js

import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useLocation } from 'react-router-dom';


const baseUrl = process.env.REACT_APP_BASE_URL;

const LoginPage = ({isStrictSearch=false}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const location = useLocation();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (phoneNumber.length === 10) {
      setIsOtpSent(true);
      setError('');
      setMessage('');
      try {
        const response = await fetch(`${baseUrl}/ivr/user/checkUser/`, {
          method: 'POST',
          body: JSON.stringify({ phone: phoneNumber, isStrictSearch }),
          headers: {
            'Content-Type': 'application/json',
          }
        });

        const data = await response.json();

        if (!response.ok) {
          setError(data.message);
          return;
        } else {
            setMessage(data.message);
        }

      } catch (error) {
        setError('Error fetching data: ' + error.message);
      }
    } else {
      setError('Please enter a valid phone number.');
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const response = await fetch(`${baseUrl}/ivr/user/validateOtp/${phoneNumber}/${otp}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.message);
        return;
      } else {
        setMessage(data.message);
      }
      localStorage.setItem('user', phoneNumber);

      window.location.reload();
    } catch (error) {
      setError('Error fetching data: ' + error.message);
    }
  };

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="d-flex flex-md-row flex-column align-items-center justify-content-center gap-4 mb-5">
          <img 
            src="/logo.png" 
            alt="Shravan Audiobooks Logo" 
            className="shravan-audiobooks-logo" 
          />
          <div>
            <h1 className="text-center text-xl font-bold">Shravan Audiobooks Library</h1>
            <p className="text-center">A NAB Delhi innovation. Supported by United Way Delhi</p>
          </div>
      </div>
      <div className="border p-4 rounded" style={{ maxWidth: '360px', width: '100%' }}>
        <h2 className="text-center">Login</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={isOtpSent ? handleLogin : handleSendOtp}>
          <Form.Group controlId="formPhoneNumber">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your registered phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </Form.Group>

          <div className="d-flex flex-column">
            <Button variant="primary" type="button" onClick={handleSendOtp} className="w-100 mt-2">
              {isOtpSent ? 'Re-send OTP' : 'Send OTP'}
            </Button>
          </div>

          {isOtpSent && (
            <div className="d-flex flex-column mt-2">
              <Form.Group controlId="formOtp">
                <Form.Label>OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </Form.Group>
            </div>
          )}

          {isOtpSent && (
            <div className="d-flex flex-column">
              <Button variant="primary" type="submit" className="w-100 mt-2">
                Login
              </Button>
            </div>
          )}

          {error && <p style={{ color: 'red' }}>{error}</p>}
          {message && <p style={{ color: 'green' }}>{message}</p>}
        </Form>
      </div >
    </Container >
  );
};

export default LoginPage;

